import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ThemedCheckbox } from '@themes/defaultThemeProps';
import styles from 'assets/jss/material-dashboard-pro-react/views/tenantStyle.js';
import Button from 'components/CustomButtons/Button.js';
import { useEffect, useState } from 'react';

const useStyles = makeStyles((theme) => ({
  ...styles,
  dialogContent: {
    minWidth: 400,
    minHeight: 200,
  },
  formControl: {
    marginTop: 16,
  },
}));

export default function SupportedLanguagesModal({
  open,
  onClose,
  onSave,
  initialLanguages = [],
  availableLanguages = [],
}) {
  const classes = useStyles();
  const [selectedLanguages, setSelectedLanguages] = useState(
    Array.isArray(initialLanguages) ? initialLanguages : []
  );
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      const languages = Array.isArray(initialLanguages) ? initialLanguages : [];
      setSelectedLanguages(languages);
      setError('');
    }
  }, [open, initialLanguages]);

  const handleCheckboxChange = (event) => {
    const language = event.target.name;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedLanguages([...selectedLanguages, language]);
    } else {
      setSelectedLanguages(selectedLanguages.filter((lang) => lang !== language));
    }

    if (selectedLanguages.length > 0 || isChecked) {
      setError('');
    }
  };

  const handleSave = () => {
    if (selectedLanguages.length === 0) {
      setError('At least one language must be selected');
      return;
    }

    onSave(selectedLanguages);
    onClose();
  };

  const handleCancel = () => {
    setError('');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby='supported-languages-dialog-title'
      maxWidth='sm'
      fullWidth
    >
      <DialogTitle id='supported-languages-dialog-title'>
        Edit Supported Languages
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <FormControl
          variant='standard'
          component='fieldset'
          fullWidth
          error={Boolean(error)}
          className={classes.formControl}
        >
          <FormLabel component='legend'>Choose options</FormLabel>
          {availableLanguages.map((language) => {
            const isChecked = selectedLanguages.includes(language);
            return (
              <FormControlLabel
                key={language}
                control={
                  <ThemedCheckbox
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    name={language}
                    color='primary'
                  />
                }
                label={language}
              />
            );
          })}
          {error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button color='secondary' onClick={handleCancel}>
          Cancel
        </Button>
        <Button color='rose' onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
